module.exports = __webpack_public_path__ + "img/loyalty-program-article-icon-orange.718fcb95.svg";